var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48818 0.793057C8.71125 0.402314 9.28875 0.402315 9.51181 0.793054L17.4248 14.6541C17.6352 15.0226 17.3722 15.5 16.913 15.5H1.08701C0.62783 15.5 0.364819 15.0226 0.575201 14.6541L8.48818 0.793057Z",
    fill: "#FFDAAE",
    stroke: "#FF9704"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7931 5L9.61379 11.2179H8.30345L8.12414 5H9.7931ZM9.0069 14C8.72184 14 8.48276 13.9103 8.28966 13.7308C8.09655 13.5513 8 13.3291 8 13.0641C8 12.7991 8.09655 12.5769 8.28966 12.3974C8.48276 12.2179 8.72184 12.1282 9.0069 12.1282C9.28276 12.1282 9.51724 12.2179 9.71034 12.3974C9.90345 12.5769 10 12.7991 10 13.0641C10 13.3291 9.90345 13.5513 9.71034 13.7308C9.51724 13.9103 9.28276 14 9.0069 14Z",
    fill: "#FF9704"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.fe7faa295401fda1eca381b20a35d8cb.svg";
export { ForwardRef as ReactComponent };